// bundle-builder.js
export default (Alpine) => {
    Alpine.data("blogFilters", (blogHandle) => ({
      blogHandle: blogHandle,
      selectedFilter: null,
      blogGrid: null,
      headline: null,

      
      init() {
        this.blogGrid = document.getElementById('blog-grid');
        const currentUrl = window.location.href;
        if (currentUrl.includes('/tagged/')) {
            let tagHandle = currentUrl.split('/tagged/')[1];
            tagHandle = tagHandle.split('?')[0];
            this.selectedFilter = tagHandle;
        } else {
            this.selectedFilter = '';
        }
      },

      async onFilterChange(event) {
        event.preventDefault()
        
        let url = '';

        if (event.target.value === 'all') {
            url = `/blogs/${this.blogHandle}?section_id=blog-grid&view=grid`;
        } else {
            url = `/blogs/${this.blogHandle}/tagged/${this.selectedFilter}?section_id=blog-grid`;
        }

        fetch(url)
        .then(response => response.text())
        .then(html => {

          const htmlParsed = new DOMParser().parseFromString(html, 'text/html');
          const blogGrid = htmlParsed.querySelector('#blog-grid');

          let newUrl = url.split('?')[0];
          window.history.pushState({}, '', newUrl);
          this.headline = event.target.closest('select').options[event.target.closest('select').selectedIndex].dataset.name
          document.getElementById('blog-heading-title').innerHTML = this.headline;

          if (!blogGrid) {
            this.blogGrid.innerHTML = '<div class="text-center text-2xl font-semibold font-bebasNeueExpanded">No results found</div>';
            return;
          }

          this.blogGrid.innerHTML = blogGrid.innerHTML;
        })
        .catch(error => {
          console.error('Error:', error);
        });
      },

    }));
  };